module.exports = __webpack_public_path__ + "img/dcmm_11.1d0d40a1.png";